module.exports = __webpack_public_path__ + "static/media/WatermarkImg1.3f309fab.png";